<script setup>
import { inject, ref } from 'vue';
import { __, registrationInfo, getFormValuesFromLocalStorage, checkIfOnlyEsim } from '@/utils';

const savedFields = getFormValuesFromLocalStorage();
const userData = registrationInfo(savedFields);
const { setActiveStep } = inject('step');
const clientType = savedFields.activeTab === 'Business Client' ? 'company' : 'subscriber';

const Street = ref('');
const Settlement = ref('');
const homeNumber = ref('')
const onlyEsim = ref(checkIfOnlyEsim());

if (savedFields[`${clientType}AddressType`] === 'byAddress') {
	Street.value = savedFields[`${clientType}Street`];
	Settlement.value = savedFields[`${clientType}Settlement`];
	homeNumber.value = savedFields[`${clientType}NumberHome`]
} else {
	Settlement.value = savedFields[`${clientType}POSettlement`];
	homeNumber.value = savedFields[`${clientType}PO`]
}


if (!savedFields[`${clientType}SendSimToAddress`]) {
	Street.value = savedFields[`${clientType}ShippingStreet`];
	Settlement.value = savedFields[`${clientType}ShippingSettlement`];
	homeNumber.value = savedFields[`${clientType}ShippingNumberHome`]
}
</script>
<template>
	<div class="details details--small-margin-bottom">
		<div class="details__group">
			<div class="details__head">
				<h6>
					{{ __('Subscription details') }}
				</h6>

				<button class="link-icon" @click="setActiveStep(2)" type="button">
					<span>
						<i class="ico ico--edit"></i>
					</span>

					<span>
						{{ __('Edit') }}
					</span>
				</button><!-- /.ico-text -->
			</div><!-- /.details__head -->

			<div class="details__body">
				<div class="details__inner">
					<p>
						{{ userData.first_name }} {{ userData.last_name }}

						<br>

						ת.ז {{ userData.personal_id }}
					</p>
				</div><!-- /.details__inner -->

				<div class="details__inner">
					<p>
						{{ __("Subscription address") }}:

						{{ Street }}, {{ homeNumber }} , {{
						Settlement }}
					</p>
				</div><!-- /.details__inner -->
			</div><!-- /.details__body -->
		</div><!-- /.details__group -->

		<div class="details__group" v-if="!onlyEsim">
			<div class="details__head">
				<h6>
					{{ __('Delivery details') }}
				</h6>

				<button class="link-icon" @click="setActiveStep(2)" type="button">
					<span>
						<i class="ico ico--edit"></i>
					</span>

					<span>
						{{ __('Edit') }}
					</span>
				</button><!-- /.ico-text -->
			</div><!-- /.details__head -->

			<div class="details__body">
				<div class="details__inner">
					<p>
						{{ __('Shipping Address') }}
						{{ Street }}, {{ homeNumber }} , {{
						Settlement }}
					</p>
				</div><!-- /.details__inner -->
			</div><!-- /.details__body -->
		</div><!-- /.details__group -->
	</div><!-- /.details -->
</template>
